import StatusDescriptionPanel from './StatusDescriptionPanel';

export default StatusDescriptionPanel;
